import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sweetAlert } from 'src/app/utils/swal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
@UntilDestroy()
export class ForgotPasswordComponent implements OnInit  {
  forgotPasswordForm!: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  backToLogin() {
    this.router.navigateByUrl('/login')
  }

  onSubmit() {
    this.submitted = true;

    if (this.forgotPasswordForm.invalid) {
      return;
    }
    const payload = { email: this.forgotPasswordForm.value.email };
    this.authService
      .forgetPassword(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.forgotPasswordForm.reset();
          this.submitted = false;
          sweetAlert('Success', 'We have sent a password reset link to your email. Please check your inbox.', 'success', 'OK');
        },
        error: (err) => {
          sweetAlert('Error', err, 'error', 'Ok');
        }
      });
  }
  get form() {
    return this.forgotPasswordForm.controls;
  }

}
